const tagsView = {
  refresh: "刷新",
  close: "关闭",
  closeOthers: "关闭其它",
  closeAll: "关闭所有"
} 
export default tagsView